import { ProfilerQuestion } from './profilers';

export enum SurveyCategory {
  Automotive = 'AUTOMOTIVE',
  Childcare = 'CHILDCARE',
  Education = 'EDUCATION',
  Fashion = 'FASHION',
  FinanceAndBanking = 'FINANCE_AND_BANKING',
  FoodAndDrink = 'FOOD_AND_DRINK',
  General = 'GENERAL',
  Healthcare = 'HEALTHCARE',
  HomeAndGarden = 'HOME_AND_GARDEN',
  LifestyleAndHobbies = 'LIFESTYLE_AND_HOBBIES',
  MediaAndEntertainment = 'MEDIA_AND_ENTERTAINMENT',
  PersonalCareAndBeauty = 'PERSONAL_CARE_AND_BEAUTY',
  Pets = 'PETS',
  Shopping = 'SHOPPING',
  Sports = 'SPORTS',
  Technology = 'TECHNOLOGY',
  ToysAndGames = 'TOYS_AND_GAMES',
  Travel = 'TRAVEL',
  WorkAndBusinessManagement = 'WORK_AND_BUSINESS_MANAGEMENT',
}

export enum SurveyStatus {
  Success = 'SUCCESS',
  Drop = 'DROP',
  NotMatch = 'NOT_A_MATCH',
}

export enum SurveyType {
  Guaranteed = 'GUARANTEED',
  High = 'HIGH_CHANCE',
  Medium = 'MEDIUM_CHANCE',
}

export interface SurveyHistoryItem {
  category: SurveyCategory;
  datetime: string;
  effort: number;
  points: number;
  status: SurveyStatus;
  type: SurveyType;
}

export interface CommitmentOption {
  id: string;
  category: SurveyCategory;
  effort: number;
  points: number;
  size: string;
  type: SurveyType;
  image?: string;
  image_position?: string;
}

export enum CommitmentActionTypes {
  EnterStudy = 'ENTER_STUDY',
  CommitmentDone = 'COMMITMENT_DONE',
  AskProfiler = 'ASK_PROFILER',
  DetachFromCommitment = 'DETACH_FROM_COMMITMENT',
  SupplierCommitmentDone = 'SUPPLIER_COMMITMENT_DONE',
  SupplierDetachFromCommitment = 'SUPPLIER_DETACH_FROM_COMMITMENT',
  CommitmentStatusTab = 'COMMITMENT_STATUS_TAB',
}

export enum CommitmentDropType {
  NewCommitmentStarted = 'NEW_COMMITMENT_STARTED',
  DropStudyDetected = 'DROP_STUDY_DETECTED',
}

export enum DetachFromCommitmentReason {
  BadSubmission = 'BAD_SUBMISSION',
  NoActiveCommitment = 'NO_ACTIVE_COMMITMENT',
  NotLatestActionOfOngoingCommitment = 'NOT_LATEST_ACTION_OF_ONGOING_COMMITMENT',
  StudyInProgress = 'STUDY_IN_PROGRESS',
}

export interface CommitmentAction<Type extends CommitmentActionTypes> {
  type: Type;
  data: Type extends CommitmentActionTypes.EnterStudy
    ? {
        study_id: number;
        attempt_id: number;
        url: string;
      }
    : Type extends CommitmentActionTypes.AskProfiler
    ? {
        profiler: ProfilerQuestion;
        progress: number;
        seconds_remaining: number;
        skippable: boolean;
        last_seconds_accrued: number;
        total_commitment_length: number;
      }
    : Type extends CommitmentActionTypes.CommitmentDone
    ? {
        points_earned: number;
        success: boolean;
        drop_type?: CommitmentDropType;
      }
    : Type extends CommitmentActionTypes.SupplierCommitmentDone
    ? {
        return_url: string;
      }
    : Type extends CommitmentActionTypes.SupplierDetachFromCommitment
    ? {
        reason: string;
      }
    : Type extends CommitmentActionTypes.CommitmentStatusTab
    ? {}
    : {
        // CommitmentActionTypes.DetachFromCommitment
        reason: DetachFromCommitmentReason;
      };
}

export interface Commitment<
  Type extends CommitmentActionTypes = CommitmentActionTypes
> {
  spin_result: any;
  commitment_id: number;
  action: CommitmentAction<Type>;
}

export enum CommitmentStatusState {
  CommitmentScreening = 'commitment_screening',
  CommitmentInSurvey = 'commitment_in_survey',
  CommitmentOutcome = 'commitment_outcome',
  CommitmentStart = 'commitment_start',
  // Profiler-specific commitment start states
  CommitmentStartStateProfilerTimeCredits = 'commitment_start_state_profiler_time_credits',
  CommitmentStartStateProfilerNewUsers = 'commitment_start_state_profiler_new_users',
  CommitmentStartStateProfilerReturning = 'commitment_start_state_profiler_returning',
}

export interface CommitmentCurrentState {
  commitment_id: number;
  action: CommitmentAction<CommitmentActionTypes>;
  substatus: number;
  closed: boolean;
  // for the header/description text
  localization_profiler?: ProfilerQuestion;
  // for actual profiler question rendering
  question_profiler?: ProfilerQuestion;
  status_state: CommitmentStatusState;
  accrued_effort: number;
}
